import getTimeZoneOffsetMinutes from './getTimeZoneOffsetMinutes'

/**
 * Converts a wall-clock date and time in an IANA time zone to a UTC ISO
 * string, e.g. ('2026-11-04', '19:00', 'Europe/Stockholm') → '2026-11-04T18:00:00.000Z'
 */
export default function zonedDateTimeToUtc(
  date: string,
  time: string,
  timeZone: string,
): string {
  const [year, month, day] = date.split('-').map(Number)
  const [hours, minutes] = time.split(':').map(Number)

  const wallClockAsUtc = Date.UTC(year, month - 1, day, hours, minutes)

  // Resolve the offset twice so a DST change between the guess and the
  // result lands on the right side
  const firstGuess =
    wallClockAsUtc -
    getTimeZoneOffsetMinutes(new Date(wallClockAsUtc), timeZone) * 60000
  const utc =
    wallClockAsUtc -
    getTimeZoneOffsetMinutes(new Date(firstGuess), timeZone) * 60000

  return new Date(utc).toISOString()
}
